// Tipovi i konstante
import { PublicApiDetailPageCmp, PublicApiDetailPageProps } from "./types";
import { SETTING_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import { SIDEBAR_ITEM_SETTING } from "app/components/Sidebar/consts";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// Moduli specifični za projekt
import { Routes } from "ui/modules/settings/navigation";
import TabMenu from "ui/modules/settings/pages/tenant/components/TabMenu/TabMenu";
import { getActiveUser } from "services/api/users";
import { useSelector } from "react-redux";
import PublicApiDetailCard from "./components/PublicApiDetailCard/PublicApiDetailCard";

/**
 * Javni API tenanta: uključivanje (opt-in) i API ključevi kojima se web stranica tenanta
 * (preko servisa public.api.autobiz) predstavlja Orytron API-ju.
 */
const PublicApiDetailPage: PublicApiDetailPageCmp = (props: PublicApiDetailPageProps) => {
  const { user } = useSelector(getActiveUser);

  const title = SETTING_DETAIL_PAGE_TITLE;

  const breadcrumbs: BreadcrumbItem[] = [
    { text: SIDEBAR_ITEM_SETTING.text, route: SIDEBAR_ITEM_SETTING.route },
  ];

  if (!user) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title={`${title.text}`}
              icon={title.icon}
              iconColor={title.iconColor}
            />
            <Breadcrumb items={breadcrumbs} />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <PublicApiDetailCard />
        </div>
      </div>
    </>
  );
};

PublicApiDetailPage.route = Routes.PublicApiDetailPageRouter;

export default PublicApiDetailPage;
